'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../../core/utils');

var _utils2 = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//import '../../../../node_modules/moment/locale/fi'
//import 'moment/locale/fi';

var WinresDeparturesSearchController = function () {
    function WinresDeparturesSearchController(internetClassificationService, busService, localizationService, $scope, $rootScope, $timeout, $filter, $document, $window, departureService, regionService, analyticsService, userService, urlService, paramService) {
        _classCallCheck(this, WinresDeparturesSearchController);

        this.internetClassificationService = internetClassificationService;
        // this.busService = busService;
        this.localizationService = localizationService;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$document = $document;
        // this.busStops = [];
        this.endDateDisabled = false;
        this.$scope.showType1SelectionList = false;
        this.$window = $window;
        this.$scope.loading = false;
        this.departureService = departureService;
        this.$scope.status = [];
        this.$scope.status.isopen = false;
        this.$rootScope = $rootScope;
        this.regionService = regionService;
        this.analyticsService = analyticsService;
        this.userService = userService;
        this.urlService = urlService;
        this.paramService = paramService;

        this.typesFlat = [];

        // this is for getting Math to be used with a template. Currently only used in ongolf frontPageSearch.html
        this.$scope.Math = window.Math;
    }

    _createClass(WinresDeparturesSearchController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Default ages
            this.babyAges = this.babyAges || '0-1';
            this.childAges = this.childAges || '2-15';
            this.adultAge = this.adultAge || '16+';

            var _childAges$split = this.childAges.split('-'),
                _childAges$split2 = _slicedToArray(_childAges$split, 2),
                min = _childAges$split2[0],
                max = _childAges$split2[1];

            this.childAge = { min: min, max: max };

            if (this.hideEndDate === 'true') {
                this.endDateDisabled = true;
            }

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().DefaultStartDate
            // getContext().NumAdults
            // getContext().NumChildren
            // getContext().NumInfants
            // getContext().Passengers
            // getContext().ChildrenAges
            // getContext().DestinationCode

            // Set:
            // getContext().Passengers

            this.data = this.winresReservationContext.getContext();

            if (this.ownerMode === "true") {
                this.getOwnerData();
            }

            this.flags = [];

            // Get search criteria, hard code for now, maybe do as below later
            // If this flag is turned on, SearchReservableItems returns Search criteria properties, like if "pets are allowed" etc.
            this.flags.push('GetCriteriaValues');

            if (this.k1ExtraAllMatchedPrices === 'true') {
                this.flags.push('K1ExtraAllMatchedPrices');
            }

            if (this.orderByPrice === 'true') {
                this.flags.push('OrderByPrice');
            }

            if (this.matchStartDates === 'true') {
                this.flags.push('MatchStartDate');
            }

            this.type1Choice = this.mode == 'horizontal' || this.mode == 'empty';

            // Not ready to show search inputs yet

            this.canShowSearchInputs = false;

            this.getSearchInputVisibility();
            this.getWinresSearchInputVisibility();

            this.openState = {
                startDate: this.isStartDateOpen != 'false',
                endDate: this.isEndDateOpen == 'true',
                len: this.isLengthOpen == 'true',
                price: this.isPriceOpen == 'true',
                offer: this.isOfferOpen == 'true',
                primaryInternetClassifications: this.isPrimaryInternetClassificationsOpen == 'true', // deprecated
                secondaryInternetClassifications: this.isSecondaryInternetClassificationsOpen == 'true' // deprecated
            };

            this.createClassificationBoxes();

            this.startDatePickerOpen = false;
            this.endDatePickerOpen = false;

            //hide options if destinationCodes-parameter is set
            if (this.destinationCodes != null && this.destinationCodes != "") {
                this.allowChangeSecondaryInternetClassifications = 'false';
                this.allowChangePrimaryInternetClassifications = 'false';
            }

            this.startDate = new Date();
            if (this.defaultStartDate != null) {
                if (this.defaultStartDate[0] == "+") {
                    this.startDate = moment().add(parseInt(this.defaultStartDate), 'days').toDate();
                } else {
                    this.startDate = (0, _utils.parseISODate)(this.defaultStartDate);
                }
            }

            if (this.allowChangeStartDate !== 'false' && this.data.DefaultStartDate) {
                this.startDate = (0, _utils.parseISODate)(this.data.DefaultStartDate);
            }

            this.endDate = null;
            if (this.defaultEndDate != null) {
                if (this.defaultEndDate[0] == "+") {
                    this.endDate = moment().add(parseInt(this.defaultEndDate), 'days').toDate();
                } else {
                    this.endDate = (0, _utils.parseISODate)(this.defaultEndDate);
                }
            }

            if (this.allowChangeEndDate !== 'false' && this.data.DefaultEndDate) {
                this.endDate = (0, _utils.parseISODate)(this.data.DefaultEndDate);
            }

            this.numAdults = this.data.NumAdults || 2;
            this.numChildren = this.data.NumChildren || 0;
            this.numInfants = this.data.NumInfants || 0;

            // winresDeparturesList check capacity.
            this.$timeout(function () {
                return _this.$rootScope.$broadcast("on-passengers-num-change", { NumAdults: _this.numAdults, NumChildren: _this.numChildren, NumInfants: _this.numInfants });
            });

            this.numForm = "";

            this.numOfPeople = 0;

            if (this.numOfPeopleLimit === undefined) {
                // Default num of people limit.
                this.numOfPeopleLimit = 10;
            }

            // Convert to number.
            this.numOfPeopleLimit = +this.numOfPeopleLimit;

            this.$scope.$watchGroup(['$ctrl.type1', '$ctrl.type2', '$ctrl.type3', '$ctrl.type4', '$ctrl.type5'], function () {
                var sets = [];
                for (var i = 1; i <= 5; ++i) {
                    var prop = "type" + i;
                    if (_this[prop]) {
                        sets.push({ Level: i, Codes: [_this[prop]] });
                    }
                }
                _this.intClassSets = sets;
            });

            this.$scope.$watchGroup(['$ctrl.numAdults', '$ctrl.numChildren', '$ctrl.numInfants'], function () {
                _this.numOfPeople = _this.numAdults + _this.numChildren + _this.numInfants;

                // var adultsInData = _.filter(this.data.Passengers, passenger => {
                //     if(passenger.Gender === 'MR' || passenger.Gender === 'MS'){
                //         return true;
                //     }
                //     return false;
                // });

                // var childrenInData = _.filter(this.data.Passengers, passenger => {
                //     if(passenger.Gender === 'CH'){
                //         return true;
                //     }
                //     return false;
                // });

                // var infantsInData = _.filter(this.data.Passengers, passenger => {
                //     if(passenger.Gender === 'IN'){
                //         return true;
                //     }
                //     return false;
                // });

                // this.data.Passengers =_.concat(_.slice(adultsInData, 0, this.numAdults), _.slice(childrenInData, 0, this.numChildren), _.slice(infantsInData, 0, this.numInfants));
                // this.refresh(true);

                // this.autoUpdate();
            });

            this.$scope.range = function (start, end) {
                var result = [];
                for (var i = start; i <= end; i++) {
                    result.push(i);
                }
                return result;
            };

            if (this.defaultOffer === 'true') {
                this.showOnlyOffers = true;
            } else {
                this.showOnlyOffers = false;
            }

            var ic1 = (0, _utils.getParameter)('ic1');
            if (this.defaultInternetClassifications1 == 'auto' && ic1) {
                this.defaultInternetClassifications1 = ic1;
            }

            this.initDefaultTypes();
            this.initDefaultInternetClassifications();
            this.loadInternetClassifications();

            // Length slider set up
            this.$scope.length_slider = {
                min: 1,
                max: 30,
                options: {
                    floor: 1,
                    ceil: 30,
                    onEnd: function onEnd() {
                        _this.autoUpdate();
                    },
                    translate: function translate(num) {
                        return num + ' ' + _this.$filter('i18next')('winres_departures.days_short');
                    }
                }
            };
            if (this.slideMaxLength) {
                this.slideMaxLength = Number(this.slideMaxLength);
                this.$scope.length_slider.max = this.slideMaxLength;
                this.$scope.length_slider.options.ceil = this.slideMaxLength;
            }
            if (this.sliderMinLength) {
                this.sliderMinLength = Number(this.sliderMinLength);
                this.$scope.length_slider.min = this.sliderMinLength;
                this.$scope.length_slider.options.floor = this.sliderMinLength;
            }
            if (this.allowChangeLength == 'false') {
                this.$scope.length_slider.options.disabled = true;
            }

            // Price slider set up
            this.$scope.price_slider = {
                min: 0,
                max: 5000,
                options: {
                    floor: 0,
                    ceil: 5000,
                    onEnd: function onEnd() {
                        _this.autoUpdate();
                    },
                    translate: function translate(num) {
                        return num + ' €';
                    }
                }
            };
            if (this.sliderMaxPrice) {
                this.sliderMaxPrice = Number(this.sliderMaxPrice);
                this.$scope.price_slider.max = this.sliderMaxPrice;
                this.$scope.price_slider.options.ceil = this.sliderMaxPrice;
            }
            if (this.sliderMinPrice) {
                this.sliderMinPrice = Number(this.sliderMinPrice);
                this.$scope.price_slider.min = this.sliderMinPrice;
                this.$scope.price_slider.options.floor = this.sliderMinPrice;
            }
            if (this.allowChangePrice == 'false') {
                this.$scope.price_slider.options.disabled = true;
            }

            //datepickers set up

            this.$scope.datepicker_options_start = {
                showWeeks: true,
                minDate: new Date(),
                startingDay: 1,
                maxMode: 'day',
                minMode: 'day',
                showISOWeekNumbers: true,
                locale: {
                    weekLabel: 'W'
                }
            };

            this.$scope.datepicker_options_end = _.clone(this.$scope.datepicker_options_start);

            if (this.limitDateByData === "true") {

                this.startDate = new Date(this.data.DefaultStartDate);
                this.DefaultStartDate = new Date(this.data.DefaultStartDate);
                this.DefaultEndDate = new Date(this.data.DefaultEndDate);

                this.$scope.$watchGroup(['$ctrl.data.DefaultEndDate', '$ctrl.data.DefaultStartDate'], function () {
                    if (_this.DefaultStartDate != new Date(_this.data.DefaultStartDate) || _this.DefaultEndDate != new Date(_this.data.DefaultEndDate)) {
                        _this.startDate = new Date(_this.data.DefaultStartDate);
                        _this.endDate = new Date(_this.data.DefaultEndDate);

                        // this driggers the startDate watch so the date updates automatically
                        _this.DefaultStartDate = new Date(_this.data.DefaultStartDate);
                        _this.DefaultEndDate = new Date(_this.data.DefaultEndDate);

                        _this.$scope.datepicker_options_start.minDate = moment(_this.DefaultStartDate);
                        _this.$scope.datepicker_options_start.maxDate = moment(_this.DefaultEndDate);
                    }
                });
            }

            this.getAutoSelectEndDate();

            this.$scope.$watch('$ctrl.startDate', function () {
                //console.log(this.startDate);
                if (_this.startDate) {
                    _this.getAutoSelectEndDate();
                    _this.$scope.datepicker_options_end.minDate = _this.startDate;

                    if (_this.updateOnStartDateChange === "true") {
                        _this.update(false);
                        //this.closeStartDatePicker();
                    }
                }
            });
            this.$scope.$watchGroup(['$ctrl.endDate', '$ctrl.startDate', '$ctrl.showOnlyOffers'], function () {
                if (_this.endDate !== null && _this.startDate > _this.endDate) {
                    return;
                } else {
                    _this.autoUpdate();
                }
            });

            this.$scope.$watch('$ctrl.showOnlyOffers', function () {
                if (_this.endDate !== null && _this.startDate > _this.endDate) {
                    return;
                } else {
                    _this.autoUpdate();
                }
            });

            var isInitial = true;
            this.$scope.$watch('$ctrl.departure_types', function () {
                if (isInitial) {
                    return;
                }
                if (_this.endDate !== null && _this.startDate > _this.endDate) {
                    return;
                } else {
                    _this.autoUpdate();
                }
            }, true);

            this.$scope.$watch('$ctrl.types2', function () {
                if (isInitial) {
                    return;
                }
                if (_this.endDate !== null && _this.startDate > _this.endDate) {
                    return;
                } else {
                    _this.autoUpdate();
                }
            }, true);

            if (this.useCurrentDestination == 'true') {
                this.$scope.$watch('$ctrl.data.DestinationCode', function () {
                    // Update on destination code change.
                    _this.update(true);
                });
            }

            // Passenger count refresh for activities in kohdesivu.
            if (this.useSpecificClassification === 'AK') {
                this.$scope.$watchGroup(['$ctrl.data.NumAdults', '$ctrl.data.NumChildren', '$ctrl.data.NumInfants'], function () {
                    _this.update(true);
                });
            }

            this.$timeout(function () {
                isInitial = false;
            });

            if (this.searchOnInit === 'true' && this.defaultInternetClassifications1 == null) {
                // this is in timeout so watches get a chance to alter dates.
                this.$timeout(function () {
                    _this.update(false);
                });
            }

            // if(this.bus == 'true'){
            //     this.busService.getBusStops({}).then(stops => {
            //         this.busStops = stops;
            //         console.log("Bus stops are: ", this.busStops);
            //     });
            // }

            this.ChildrenAges = this.data.ChildrenAges || [];

            this.$scope.$watch(function () {
                return _this.numChildren;
            }, function () {
                for (var i = 0; i < _this.numChildren; i++) {
                    if (i >= _this.ChildrenAges.length) {
                        _this.ChildrenAges.push({ "Age": 3 });
                    }
                }
                if (_this.numChildren < _this.ChildrenAges.length) {
                    _this.ChildrenAges.length = _this.numChildren;
                }
            });

            this.$scope.$watch(function () {
                return _this.ChildrenAges;
            }, function () {
                _this.data.ChildrenAges = _this.ChildrenAges;
                _this.autoUpdate();
            }, true);

            if (this.hideEndDateWhenSpecifiedSingleType !== undefined) {
                this.$scope.$watch(function () {
                    return _this.type1;
                }, function () {
                    if (_this.type1 == _this.hideEndDateWhenSpecifiedSingleType) {
                        _this.showEndDate = "false";
                    } else {
                        _this.showEndDate = "true";
                    }
                }, true);
            }

            // Make sure it is integer
            if (this.earliestNDeparturesPerDestination && isNaN(parseInt(Number(this.earliestNDeparturesPerDestination)))) {
                console.error("[WDS] EarliestNDeparturesPerDestination is set, but it is not a whole number! Clearing the setting... :", this.earliestNDeparturesPerDestination);
                this.earliestNDeparturesPerDestination = null;
            }

            this.numRooms = 1;
            this.$scope.$watch(function () {
                return _this.numRooms;
            }, function () {
                _this.autoUpdate();
            });

            // hide loading indicator.
            this.$rootScope.$on("stop-loading-people", function () {
                return _this.$scope.loading = 0;
            });

            if (this.$scope.showRegionPicker) {
                this.getRegions();
            }

            if (this.$scope.showDatePresetPicker) {
                this.datePresets = this.getDatePresets();
                if (this.defaultDatePreset) {
                    this.defaultDatePreset = this.defaultDatePreset.replace(/ /g, '');
                    var select = _.filter(this.datePresets, function (datePreset) {
                        return datePreset.name === _this.defaultDatePreset;
                    });
                    if (select.length > 0) {
                        this.selectedDatePreset = select[0]; // Select default date preset.
                        this.onDatePresetChange(); // Update start and end date.
                    }
                }
            }

            // Read url query string in front page.
            if ( /*this.urlService.hasQueryString() &&*/ // Url with query string (?param1=1&param2=2)
            !this.urlService.isKohdeSivu()) {
                // Must not be kohdesivu.
                this.createUrlWatcher();
            }

            this.$scope.$watchCollection('$ctrl.data.Passengers', function () {
                _this.updateArrivalAges();
            }, true);

            this.getWinresParams();

            // this.$scope.$watch(() => this.ChildrenAges, () => {
            //     this.childrenInfo = [];
            //     _.each(this.ChildrenAges, child => {
            //         var childrenAge = new Date();
            //         childrenAge.setFullYear(childrenAge.getFullYear() - child.Age);
            //         var childrenBD = this.$filter('date')(childrenAge, "yyyy-MM-dd") + "";
            //         console.log(childrenBD);
            //         this.childrenInfo.push({"BirthDate": childrenBD, "Gender": "CH"});
            //     });

            //     if(this.data.Passengers == null || this.data.Passengers.length == 0 || this.data.Passengers[0] == null){
            //         this.data.Passengers = this.childrenInfo;
            //     }else{
            //         var j = 0;
            //         for(var i = 0; i < this.data.Passengers.length; i++){
            //             if(this.data.Passengers[i].Gender == "CH"){
            //                 this.data.Passengers[i] = this.childrenInfo[j];
            //                 j++;
            //             }
            //         }
            //         while(j < this.childrenInfo.length){
            //             this.data.Passengers.push(this.childrenInfo[j]);
            //             j++;
            //         }
            //     }
            // }, true);
        }
    }, {
        key: 'createUrlWatcher',
        value: function createUrlWatcher() {
            var _this2 = this;

            this.urlService.addForcedClassifications([this.defIntClasses1, this.defIntClasses2, this.defIntClasses3, this.defIntClasses4, this.defIntClasses5]);

            // Url reader function.
            this.urlService.addReader(function (params) {
                _this2.numAdults = params.numAdults != null ? +params.numAdults : _this2.numAdults;
                _this2.numChildren = params.numAdults != null ? +params.numChildren : _this2.numChildren;
                _this2.numInfants = params.numInfants != null ? +params.numInfants : _this2.numInfants;
                _this2.startDate = params.startDate != null ? (0, _utils.parseISODateWithLeadingZeros)(params.startDate) : _this2.startDate;
                _this2.endDate = params.endDate != null ? (0, _utils.parseISODateWithLeadingZeros)(params.endDate) : _this2.endDate;
                _this2.type1 = params.type != null ? params.type : _this2.type1;
                _this2.region = params.region != null ? params.region : _this2.region;
                _this2.classifications = _this2.urlService.getClassifcationsInUse(params);
                _this2.producers = params.dp != null ? params.dp.split(',') : [];

                if (_this2.urlWatcherSearch || _this2.searchOnInit !== 'true') {
                    // Prevent search with null EndDate.
                    // Trigger search.
                    _this2.update(true);
                }

                // Trigger search next time.
                _this2.urlWatcherSearch = true;
            });

            // Watch url params.
            this.urlService.createUrlWatcher([{
                name: 'numAdults',
                value: function value() {
                    return _this2.numAdults;
                },
                type: 'default',
                watch: true
            }, {
                name: 'numChildren',
                value: function value() {
                    return _this2.numChildren;
                },
                type: 'default',
                watch: true
            }, {
                name: 'numInfants',
                value: function value() {
                    return _this2.numInfants;
                },
                type: 'default',
                watch: true
            }, {
                name: 'startDate',
                value: function value() {
                    return _this2.startDate;
                },
                type: 'date',
                watch: true
            }, {
                name: 'endDate',
                value: function value() {
                    return _this2.endDate;
                },
                type: 'date',
                watch: true
            }, {
                name: 'type',
                value: function value() {
                    return _this2.type1;
                },
                type: 'default',
                watch: true
            }, {
                name: 'region',
                value: function value() {
                    return _this2.region;
                },
                type: 'default',
                watch: true
            }, {
                name: 'dc1',
                value: function value() {
                    return _.map(_this2.classifications[0], function (c) {
                        return c.code;
                    });
                },
                type: 'default',
                watch: false
            }, {
                name: 'dc2',
                value: function value() {
                    return _.map(_this2.classifications[1], function (c) {
                        return c.code;
                    });
                },
                type: 'default',
                watch: false
            }, {
                name: 'dc3',
                value: function value() {
                    return _.map(_this2.classifications[2], function (c) {
                        return c.code;
                    });
                },
                type: 'default',
                watch: false
            }, {
                name: 'dc4',
                value: function value() {
                    return _.map(_this2.classifications[3], function (c) {
                        return c.code;
                    });
                },
                type: 'default',
                watch: false
            }, {
                name: 'dc5',
                value: function value() {
                    return _.map(_this2.classifications[4], function (c) {
                        return c.code;
                    });
                },
                type: 'default',
                watch: false
            }, {
                name: 'dp',
                value: function value() {
                    return _this2.producers;
                },
                type: 'default',
                watch: false
            }]);
        }
    }, {
        key: 'getRegions',
        value: function getRegions() {
            var _this3 = this;

            var language = this.localizationService.getLanguage();
            this.regionService.getRegions(language).then(function (result) {
                return _this3.regions = result;
            });
        }
    }, {
        key: 'getDatePresets',
        value: function getDatePresets() {
            var _this4 = this;

            var datePresets = this.datePreset.replace(/ /g, '').split(',');
            var datePresetArray = [];
            _.each(datePresets, function (datePreset) {
                var params = datePreset.split(';');
                var name = params[0];
                datePresetArray.push({
                    title: name + ' ' + (0, _utils.formatFinnishTwoDates)(_this4.$filter('i18next')('winres_departures.select_date_preset_days'), params[1], params[2], _this4.localizationService.getLanguage()),
                    name: name,
                    startDate: params[1],
                    endDate: params[2]
                });
            });
            return datePresetArray;
        }
    }, {
        key: 'onDatePresetChange',
        value: function onDatePresetChange() {
            // If no preset, use old date.
            if (!this.dateBackup) {
                this.startDateBackup = this.startDate;
                this.endDateBackup = this.endDate;
                this.dateBackup = true;
            }

            // Change date picker dates.
            if (this.selectedDatePreset) {
                this.startDate = (0, _utils.parseISODate)(this.selectedDatePreset.startDate);
                this.endDate = (0, _utils.parseISODate)(this.selectedDatePreset.endDate);
            } else if (this.dateBackup) {
                this.startDate = this.startDateBackup;
                this.endDate = this.endDateBackup;
            }
        }
    }, {
        key: 'addAdult',
        value: function addAdult() {
            this.numAdults++;
        }
    }, {
        key: 'addChild',
        value: function addChild() {
            this.numChildren++;
        }
    }, {
        key: 'addInfant',
        value: function addInfant() {
            this.numInfants++;
        }
    }, {
        key: 'reduceAdult',
        value: function reduceAdult() {
            this.numAdults--;
        }
    }, {
        key: 'reduceChild',
        value: function reduceChild() {
            this.numChildren--;
        }
    }, {
        key: 'reduceInfant',
        value: function reduceInfant() {
            this.numInfants--;
        }
    }, {
        key: 'updateArrivalAges',
        value: function updateArrivalAges() {
            var _this5 = this;

            // Infant arrival age is 2
            _.each(_.filter(this.data.Passengers, function (passenger) {
                return passenger.IsInfant;
            }), function (infant) {
                infant.ArrivalAge = 2;
            });

            // Set child arrival ages
            // Assuming children are in same order as ChildrenAges
            _.each(_.filter(this.data.Passengers, function (passenger) {
                return passenger.IsChild;
            }), function (child, idx) {
                child.ArrivalAge = _this5.data.ChildrenAges[idx].Age;
            });

            // Get adult arrival age from adultAge
            _.each(_.filter(this.data.Passengers, function (passenger) {
                return passenger.IsAdult || passenger.IsCustomer;
            }), function (adult) {
                adult.ArrivalAge = +_this5.adultAge.split('+')[0];

                if (adult.IsCustomer) {
                    _this5.data.Customer.IsCustomer = true;
                    _this5.data.Customer.ArrivalAge = adult.ArrivalAge;
                }
            });
        }
    }, {
        key: 'refresh',
        value: function refresh(open) {
            if (open) {} else {
                this.update(true);
            }
        }
    }, {
        key: 'getSearchInputVisibility',
        value: function getSearchInputVisibility() {
            this.$scope.showType = !this.destinationCodes && this.allowChangePrimaryInternetClassifications !== 'false' && this.internetClassificationTitle1 !== 'false';

            // Int class 2 - 5 select.
            // Note: undefined check is to hide int class select by default.
            // This rule does not apply for int class 1, however, and is shown by default.
            this.$scope.showType2 = this.internetClassificationTitle2 && this.internetClassificationTitle2 !== 'false';
            this.$scope.showType3 = this.internetClassificationTitle3 && this.internetClassificationTitle3 !== 'false';
            this.$scope.showType4 = this.internetClassificationTitle4 && this.internetClassificationTitle4 !== 'false';
            this.$scope.showType5 = this.internetClassificationTitle5 && this.internetClassificationTitle5 !== 'false';

            this.$scope.showRegionPicker = this.showRegionPicker && this.showRegionPicker !== 'false';
            this.$scope.showDatePresetPicker = this.showDatePresetPicker && this.showDatePresetPicker !== 'false';
            this.$scope.showBusStops = this.showBusStops && this.showBusStops !== 'false';
        }

        // Get search input visibility from db

    }, {
        key: 'getWinresSearchInputVisibility',
        value: function getWinresSearchInputVisibility() {
            var _this6 = this;

            this.$scope.$watch(function () {
                return _this6.userService.getCurrentUser();
            }, function (user) {
                if (user) {
                    var discountInUse = user.getParameter("DiscountInUse") === "TRUE";
                    _this6.$scope.showDiscountCode = discountInUse && _this6.showDiscountCode && _this6.showDiscountCode !== 'false';

                    _this6.countOptionalSearchInputs();

                    // Is ready to show search inputs
                    _this6.canShowSearchInputs = true;
                }
            });
        }
    }, {
        key: 'countOptionalSearchInputs',
        value: function countOptionalSearchInputs() {
            this.optionalSearchInputs = !!this.$scope.showType + !!this.$scope.showType2 + !!this.$scope.showType3 + !!this.$scope.showType4 + !!this.$scope.showType5 + !!this.$scope.showRegionPicker + !!this.$scope.showDatePresetPicker + !!this.$scope.showDiscountCode;
        }

        // This code is here so we can make a full page reload when changing
        // the amount of persons on kohdesivu

    }, {
        key: 'okClickNumberOfPeopleShoppingTabs',
        value: function okClickNumberOfPeopleShoppingTabs() {
            // Add or remove passengers.
            var numOfPeopleChanged = false;

            if (this.data.NumAdults != this.numAdults || this.data.NumChildren != this.numChildren || this.data.NumInfants != this.numInfants) {
                // Clear session
                this.data.Products = [];
                this.data.ProductGroups = [];
                this.data.BusSession = [];
                this.data.Transport = [];

                // Delete current passengers, add new passengers and update passengers in url.
                this.updatePassengerAmounts(this.numAdults, this.numChildren, this.numInfants);

                numOfPeopleChanged = true;
            }

            this.updateArrivalAges();

            // data.NumAdults, data.NumChildren and data.NumInfants handling also in winresReservationPassengerInfo
            // FIXME
            this.data.NumAdults = this.numAdults;
            this.data.NumChildren = this.numChildren;
            this.data.NumInfants = this.numInfants;

            if (numOfPeopleChanged) {
                this.$rootScope.$broadcast('number-of-people-change');
            }

            // Close number of people modal
            this.$scope.status.isopen = false;

            // Update no capacity for current departure text.
            this.$rootScope.$broadcast('on-passengers-num-change', {
                NumAdults: this.numAdults,
                NumChildren: this.numChildren,
                NumInfants: this.numInfants
            });

            // // Close the popup
            // this.$scope.loading++;
            // var criteria = this.getSearchCriteria(true);

            // // This forceFullPagereloadWhenGettingResult is checked in departuresList and if true reloads page
            // criteria.forceFullPagereloadWhenGettingResult = true;
            // document.cookie = "tab=1"; // Scroll to winres-reservation-shopping-tabs.

            // console.log("[WinresDeparturesSearch] Updated search criteria:", criteria);

            // this.onUpdate({ searchCriteria: criteria });

            // // Wait for a second before closing popup because
            // // the other loading indicator in departures list
            // // under the popup takes about a second to get started
            // this.$timeout(() => { this.$scope.status.isopen = false; },500);

            // var withReserveLink = true
            // var language = this.localizationService.getLanguage();
            // var search = this.departureService.searchReservableItems(criteria,withReserveLink,language);
            // // After amount of passengers if updated on kohdesivu,
            // // we make a search to get reservationlink we can use with full page reload
            // search.then(response => {
            //     this.$scope.loading--;
            //     console.log("Response is: ", response);
            //     if (response.Results.length > 1) {console.error("Expecting only one results. Continuing despite that..");}
            //     if(response.Results.length > 0) {
            //         console.log("We have search results");
            //         var reservationLink = response.Results[0].ReservationLink;
            //         // force full page reload using the link that was gotten from search results
            //         //window.location.assign(reservationLink);
            //     } else if (response.Results.length <= 0) {
            //         console.log("No results!");
            //         this.$scope.noResultsError = true;
            //         // This error appears probably when there is no room in the departure for the new amount of persons
            //         // or if amount of childen or infants where added and the product does not have prices for children or infants set
            //     }  else  {
            //         console.error("okClickNumberOfPeopleShoppingTabs() searchReservableItems error");
            //     }
            // }).catch(error=> {
            //   console.error("[WDS] okClickNumberOfPeopleShoppingTabs() item failed getting results. Error: ", error);
            // });
        }
    }, {
        key: 'updatePassengerAmounts',
        value: function updatePassengerAmounts(numAdults, numChildren, numInfants) {
            var urlParams = this.winresReservationContext.getUrlParams();

            // Change numAdults, numChildren and numInfants in url.
            this.urlService.setParamsToUrl({
                dn: urlParams.DestinationName,
                dc: urlParams.DestinationCode,
                pc: urlParams.ProductCode,
                bd: urlParams.StartDate,
                ed: urlParams.EndDate,
                na: numAdults,
                nc: numChildren,
                ni: numInfants,
                d: window.location.href.indexOf('/departure/') > -1 // departure in url.
            }, false);

            // Update url params in context.
            this.winresReservationContext.initUrlData();

            // Context still has passenger amounts from previous url. Change passenger amounts correctly.
            this.winresReservationContext.Params.NumAdult = numAdults;
            this.winresReservationContext.Params.NumChildren = numChildren;
            this.winresReservationContext.Params.NumInfants = numInfants;

            // Update passengers.
            this.winresReservationContext.initPassengerFieldsBase();
            this.winresReservationContext.initPassengers();
        }
    }, {
        key: 'getPassangerAmount',
        value: function getPassangerAmount() {
            if (this.numChildren == 0 && this.numInfants == 0 && this.numAdults == 0) {
                return 0 + " " + this.$filter('i18next')('number_of_people.person');
            } else if (this.numChildren == 0 && this.numInfants == 0) {
                if (this.numAdults == 1) {
                    return this.numAdults + " " + this.$filter('i18next')('number_of_people.adult');
                } else {
                    return this.numAdults + " " + this.$filter('i18next')('number_of_people.adults');
                }
            } else {
                return this.numAdults + this.numChildren + this.numInfants + " " + this.$filter('i18next')('number_of_people.person');
            }
        }
    }, {
        key: 'getPeopleAmountFromData',
        value: function getPeopleAmountFromData() {
            this.numAdults = this.data.NumAdults;
            this.numChildren = this.data.NumChildren;
            this.numInfants = this.data.NumInfants;

            this.getChildrenAgesFromData();
        }
    }, {
        key: 'getChildrenAgesFromData',
        value: function getChildrenAgesFromData() {
            var _this7 = this;

            var children = _.filter(this.data.Passengers, function (passenger) {
                return passenger.IsChild;
            });

            _.each(children, function (child, idx) {
                _this7.ChildrenAges[idx] = { 'Age': child.ArrivalAge || 3 };
            });
        }

        // Deperacted

    }, {
        key: 'setClassificationChildrenEnabled',
        value: function setClassificationChildrenEnabled(classification, enabled) {
            var _this8 = this;

            if (classification.Children.length == 0) {
                classification.Value = enabled;
            } else {
                _.each(classification.Children, function (child) {
                    _this8.setClassificationChildrenEnabled(child, enabled);
                });
            }
        }
    }, {
        key: 'initDefaultTypes',
        value: function initDefaultTypes() {
            this.departure_types = {};
            // this.destinations = [];// The array is called "destinations" but is actually just internetClassifications of Level 2 in hierarchy
            this.types = [];

            // Current, selected internet classifications as string.
            // 'AA' or 'AA,BB'
            // Use comma separated int classes for search only.
            this.type1 = (0, _utils2.clearWhiteSpace)(this.defaultInternetClassifications1);
            this.type2 = (0, _utils2.clearWhiteSpace)(this.defaultInternetClassifications2);
            this.type3 = (0, _utils2.clearWhiteSpace)(this.defaultInternetClassifications3);
            this.type4 = (0, _utils2.clearWhiteSpace)(this.defaultInternetClassifications4);
            this.type5 = (0, _utils2.clearWhiteSpace)(this.defaultInternetClassifications5);
        }
    }, {
        key: 'initDefaultInternetClassifications',
        value: function initDefaultInternetClassifications() {
            // Default internet classifications as an array.
            this.defIntClasses1 = splitClassifications(this.defaultInternetClassifications1);
            this.defIntClasses2 = splitClassifications(this.defaultInternetClassifications2);
            this.defIntClasses3 = splitClassifications(this.defaultInternetClassifications3);
            this.defIntClasses4 = splitClassifications(this.defaultInternetClassifications4);
            this.defIntClasses5 = splitClassifications(this.defaultInternetClassifications5);
        }

        // Create classification boxes with paramized values.

    }, {
        key: 'createClassificationBoxes',
        value: function createClassificationBoxes() {
            this.internetClassifications = [];

            this.createClassificationBox("", // Title placeholder.
            this.isPrimaryInternetClassificationsOpen, this.allowChangePrimaryInternetClassifications, 1);

            this.createClassificationBox("", this.isSecondaryInternetClassificationsOpen, this.allowChangeSecondaryInternetClassifications, 2);

            this.createClassificationBox("", this.isThirdInternetClassificationsOpen, this.allowChangeThirdInternetClassifications, 3);

            this.createClassificationBox("", this.isFourthInternetClassificationsOpen, this.allowChangeFourthInternetClassifications, 4);

            this.createClassificationBox("", this.isFifthInternetClassificationsOpen, this.allowChangeFifthInternetClassifications, 5);
        }
    }, {
        key: 'createClassificationBox',
        value: function createClassificationBox(title, isOpen, allowChange, icon) {
            this.internetClassifications.push({
                title: title,
                isOpen: isOpen == 'true',
                allowChange: allowChange != 'false',
                icon: icon,
                iconExist: isNaN(icon)
            });
        }
    }, {
        key: 'updateClassificationBox',
        value: function updateClassificationBox(level, title, icon, classifications) {
            this.internetClassifications[level].title = title;
            this.internetClassifications[level].icon = icon;
            this.internetClassifications[level].iconExist = isNaN(this.internetClassifications[level].icon);
            this.internetClassifications[level].classifications = classifications;
            _.map(this.internetClassifications[level].classifications, function (clas) {
                return clas.Value = false;
            }); // Used to toggle all checkboxes.
        }
    }, {
        key: 'loadInternetClassifications',
        value: function loadInternetClassifications() {
            var _this9 = this;

            // Titled internet classificaiton boxes.
            if (this.mode == "vertical") {
                var language = this.localizationService.getLanguage();
                this.internetClassificationService.loadInternetClassificationsWithTitle(language).then(function (internetClassifications) {
                    _.each(internetClassifications, function (box, level) {
                        return _this9.updateClassificationBox(level, box.Title, box.Icon, box.Classifications);
                    });
                });
            }

            // types and types2
            this.internetClassificationService.loadInternetClassifications().then(function (types) {
                // Flat internet classifications.
                _this9.typesFlat = getTypesFlat(types);

                // Internet classifications 1.
                _this9.types = _this9.getTypes(1);

                if (_this9.mode == "vertical" || _this9.setTypes2Initially === "true") {
                    _this9.types2 = _this9.getTypes(2);
                }

                // Internet classifications 3 - 5.
                _this9.types3 = _this9.getTypes(3);
                _this9.types4 = _this9.getTypes(4);
                _this9.types5 = _this9.getTypes(5);

                _this9.updateTypes();
            });
        }
    }, {
        key: 'updateTypes',
        value: function updateTypes() {
            var _this10 = this;

            if (this.type1Choice) {
                this.deselectAllTypes();
                if (!this.type1) {
                    this.type1 = (0, _utils2.clearWhiteSpace)(this.defaultInternetClassifications1);
                }
            }

            if (this.defaultInternetClassifications1 != null) {
                // Get level 2 internet classifications.
                if (this.defIntClasses1.length > 1) {
                    this.types2 = this.getChildTypesFromDefault(2);
                }

                this.onType1Change();
            }

            // Search on init.
            if (!this.defaultInternetClassifications1 != null && this.searchOnInit === 'true') {
                this.$timeout(function () {
                    return _this10.update(false);
                });
            }
        }
    }, {
        key: 'getOwnerData',
        value: function getOwnerData() {
            var _this11 = this;

            this.winresReservationContext.getOwnerData().then(function (data) {
                _this11.ownerCode = data.Number;
                _this11.limit = 25;
                _this11.minisiteType = data.MinisiteType;
                if (data.MinisiteType == 0 && _this11.dynamicPage === '0') {
                    _this11.type1 = "MA";
                    _this11.limit = 10;
                } else if (data.MinisiteType == 0 && _this11.dynamicPage === '1') {
                    _this11.type1 = "MA";
                } else if (data.MinisiteType == 0 && _this11.dynamicPage === "3") {
                    _this11.type1 = "AK";
                    _this11.ownerCode = null;
                } else {
                    _this11.type1 = "AK";
                }
                _this11.update(false);
            });
        }
    }, {
        key: 'getSearchCriteria',
        value: function getSearchCriteria(isUserInitiated) {
            var isoDateFormat = 'YYYY-MM-DD';
            var offer = this.showOnlyOffers ? true : null;
            var classifications = [[], [], [], [], []];

            if (this.type1Choice) {
                // "Type" is actually an array of classifications
                classifications[0] = this.type1 ? this.type1.split(',') : [];
                classifications[1] = this.type2 ? this.type2.split(',') : [];
                classifications[2] = this.type3 ? this.type3.split(',') : [];
                classifications[3] = this.type4 ? this.type4.split(',') : [];
                classifications[4] = this.type5 ? this.type5.split(',') : [];
            } else {
                // Get selected classifications.
                _.each(this.internetClassifications, function (box, level) {
                    _.each(box.classifications, function (clas) {
                        if (clas.Value) classifications[level].push(clas.Code);
                    });
                });

                /*classifications[0] = _.values(_.pickBy(this.internetClassifications,
                    o => o.Code in this.departure_types && this.departure_types[o.Code]));
                  _.each(this.destinations, destination => {
                    if (destination.Value === true){ //
                        classifications[destination.Level - 1].push(destination);
                    }
                });
                  // Add parents so that in-between classes
                _.each(classifications, classificationsOnLevel => {
                    _.each(classificationsOnLevel, classification => {
                      _.each(classification.Parent, parent => {
                        var current = parent;
                        while ((current = current.Parent)) {
                            classifications[current.Level - 1].push(current);
                        }
                        });
                    });
                });
                  // Convert all to codes
                classifications = _.map(classifications,
                    classificationsOnLevel =>_.map(classificationsOnLevel, 'Code'));
                  // Adding parents WILL add duplicates. Removing then is just in case
                // though as they are passed into an IN (...) expression.
                classifications = _.map(classifications, _.uniq);*/
            }

            var limit = this.limit;
            if (!limit) {
                limit = 10;
            }
            var DC = this.destinationCodes ? this.destinationCodes : null;

            if (this.useCurrentDestination == 'true') {
                DC = [this.data.DestinationCode];
            }

            if (this.useCurrentDeparture == 'true') {
                DC = [this.data.DestinationCode];
            }

            if (this.useSpecificClassification != null) {
                classifications[0] = [this.useSpecificClassification];
            }

            // var busStopID = this.bus ? this.busStop ? this.busStops[this.busStop].Id: null : null;
            // var busRoute = this.bus ? this.busStop ? this.busStops[this.busStop].Route: null : null;

            // Override classifications by url params
            // dc[n]
            if (this.classifications && this.classifications.length > 0 && _.some(this.classifications, function (c) {
                return c.length > 0;
            })) {
                _.each(this.classifications, function (cls, i) {
                    classifications[i] = _.map(cls, function (c) {
                        return c.code;
                    });
                });
            }

            var producers = this.producers || ''; // Producers from url. Primary.
            if (!_.isArray(producers)) {
                producers = _.compact(producers.split(',')); // Producers from bindings. Secondary.
            }

            return {
                IsUserInitiated: isUserInitiated,
                StartDate: this.startDate ? moment(this.startDate).format(isoDateFormat) : null,
                EndDate: this.endDate ? moment(this.endDate).format(isoDateFormat) : null,
                LengthInDaysMinimum: this.$scope.length_slider.min ? this.$scope.length_slider.min : null,
                LengthInDaysMaximum: this.$scope.length_slider.max ? this.$scope.length_slider.max : null,
                Classifications1: classifications[0],
                Classifications2: classifications[1],
                Classifications3: classifications[2],
                Classifications4: classifications[3],
                Classifications5: classifications[4],
                DestinationGroup: null,
                DestinationCodes: DC,
                ShowFullDepartures: this.showFullDepartures ? this.showFullDepartures : null,
                Types: null,
                PriceMinimum: this.$scope.price_slider.min ? this.$scope.price_slider.min : null,
                PriceMaximum: this.$scope.price_slider.max ? this.$scope.price_slider.max : null,
                IsOffer: offer,
                Limit: limit,
                Offset: 0,
                NumAdults: this.numAdults,
                NumChildren: this.numChildren,
                NumInfants: this.numInfants,
                // BusStopId: busStopID,
                // BusRoute: busRoute,
                OwnerCode: this.ownerCode,
                Flags: this.flags,
                EarliestNDeparturesPerDestination: this.earliestNDeparturesPerDestination ? Number(this.earliestNDeparturesPerDestination) : null,
                ChildAges: this.getChildAges(),
                NumRooms: this.numRooms,
                Regions: this.region ? [this.region] : [],
                Producers: producers,
                DiscountCode: this.discountCode,
                StopID: this.stopID // Bus stop ID
            };
        }
    }, {
        key: 'getChildAges',
        value: function getChildAges() {
            var childAges = [];
            _.each(this.ChildrenAges, function (child) {
                return childAges.push(child.Age);
            });
            return childAges;
        }
    }, {
        key: 'autoUpdate',
        value: function autoUpdate() {
            if (this.mode != 'horizontal' && this.mode != 'empty') {
                this.update(true);
            }
        }
    }, {
        key: 'activeUpdate',
        value: function activeUpdate() {
            this.onUpdate({ searchCriteria: { activeFilters: this.$scope.activeFilters } });
        }
    }, {
        key: 'getBtnBar',
        value: function getBtnBar() {
            return this.showBtnBar === 'false' ? false : true;
        }
    }, {
        key: 'update',
        value: function update(isUserInitiated) {
            if (!this.formIsValid()) {
                return;
            }

            var criteria = this.getSearchCriteria(isUserInitiated);
            console.log("[WinresDeparturesSearch] Updated search criteria.");
            this.onUpdate({ searchCriteria: criteria });

            this.analyticsService.dataLayerEvent('onSearch', { 'searchCriteria': criteria,
                'selectedRegion': this.region });
        }
    }, {
        key: 'formIsValid',
        value: function formIsValid() {
            // There is no form. Is valid.
            if (!this.form) {
                return true;
            }

            // Red border.
            this.touchFormInputs();

            return this.form.$valid;
        }

        // Set $touched=true for all inputs
        // Is to show red border

    }, {
        key: 'touchFormInputs',
        value: function touchFormInputs() {
            for (var k in this.form) {
                if (this.form[k] && this.form[k].hasOwnProperty('$touched')) {
                    this.form[k].$setTouched();
                }
            }
        }

        // updateBusStops(type1){
        //     this.busService.getBusStops({
        //                                   "SessionID": "9550ecff-2951-086e-1607-1f0a45bb60b4",
        //                                   Classifications1:[type1]
        //                                  }).then(stops => {
        //         this.busStops = stops;
        //         console.log("Bus stops are: ", this.busStops);
        //     });
        // }

        // updateBusStops2classifications(type1, type2){
        //     this.busService.getBusStops({
        //                                   "SessionID": "9550ecff-2951-086e-1607-1f0a45bb60b4",
        //                                   Classifications1:[type1],
        //                                   Classifications2:[type2]
        //                                 }).then(stops => {
        //         this.busStops = stops;
        //         console.log("Bus stops are: ", this.busStops);
        //     });
        // }

        // Backwards compatibility for PMT

    }, {
        key: 'onSingleTypeChange',
        value: function onSingleTypeChange() {
            if (this.singleType) {
                this.type1 = this.singleType;
            }

            this.onType1Change();
        }
    }, {
        key: 'onType1Change',
        value: function onType1Change() {
            if (this.type === '') {
                // Reset type2 select.
                this.type2 = '';
            }

            this.setType1(this.type1);

            if (!this.defIntClasses1.length <= 1) {
                // Get int classes 2 from selected type1.
                this.secondaryTypeChanges(1);
            }

            // if(this.bus == 'true'){
            //     this.updateBusStops(this.type1);
            // }
        }
    }, {
        key: 'secondaryTypeChanges',
        value: function secondaryTypeChanges() {
            var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var classifications = arguments[1];

            if (classifications === undefined) {
                // Single type of type[level].
                // Child classifications parent code.
                // compact = remove empty strings.
                classifications = _.compact([this['type' + level]]);
            }

            // Get child classifications.
            // example: type1 = 'AA', children = 'BB' and 'CC'.
            // -> types2 = 'BB' and 'CC'.
            // classifications = array of parent codes.
            this['types' + (level + 1)] = this.getTypes(level + 1, classifications);
        }

        // Find matching internet classifications hierarchy by level and by parent codes.
        // parentCodes is optional.

    }, {
        key: 'getTypes',
        value: function getTypes(level) {
            var parentCodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            return _.uniqBy(_.filter(this.typesFlat, function (type) {
                return type.Level === level && (parentCodes.length === 0 || _.some(parentCodes, function (parentCode) {
                    return parentCode === type.Parent.Code;
                }));
            }), 'Code');
        }

        // Get child internet classifications from defIntClasses[level - 1]

    }, {
        key: 'getChildTypesFromDefault',
        value: function getChildTypesFromDefault(level) {
            return this.getTypes(level, this['defIntClasses' + (level - 1)]);
        }
    }, {
        key: 'onStartDateChange',
        value: function onStartDateChange() {
            if (this.autoSelectEndDate && !this.selectedDatePreset && this.$window.location.hash.indexOf('endDate') === -1) {
                var m = new moment(this.startDate);
                this.endDate = m.add(this.autoSelectEndDate, 'days').toDate();
            }

            if (this.form.endDate && this.form.endDate.$untouched) {
                this.openEndDatePicker();
            }
            this.closeStartDatePicker();
            this.selectedDatePreset = null; // reset date preset.
        }
    }, {
        key: 'onEndDateChange',
        value: function onEndDateChange() {
            this.closeEndDatePicker();
            this.selectedDatePreset = null; // reset date preset.
        }
    }, {
        key: 'incrementDayForward',
        value: function incrementDayForward() {
            var m = new moment(this.startDate);
            this.startDate = m.add(1, 'days').toDate();

            // there is no need to change end date since there is a watch in oninit that changes the end date when autoSelectEndDate parameter is set
        }
    }, {
        key: 'incrementDayBackward',
        value: function incrementDayBackward() {
            var m = new moment(this.startDate);
            this.startDate = m.subtract(1, 'days').toDate();

            // there is no need to change end date since there is a watch in oninit that changes the end date when autoSelectEndDate parameter is set
        }

        /*
        type1(code) {
            if (arguments.length) {
                this.setType1(code);
                return code;
            } else {
                var type = this.firstSelectedType();
                return type ? type.Code : "";
            }
        }
        */

    }, {
        key: 'setType1',
        value: function setType1(code) {
            console.log('[WinresDeparturesSearch] Setting type to', code);
            this.deselectAllTypes();
            if (code === "") return;
            var type = this.typeByCode(code);
            if (!type) {
                console.warn('[WinresDeparturesSearch] Single type does not exist:', code);
                return;
            }
            // this might breack smth, made for Joiku
            this.type1 = code;
            type.Value = true;
        }
    }, {
        key: 'deselectAllTypes',
        value: function deselectAllTypes() {
            _.each(this.types, function (type) {
                if (type.Value) type.Value = false;
            });
        }
    }, {
        key: 'typeByCode',
        value: function typeByCode(code) {
            return _.find(this.types, function (type) {
                return type.Code === code;
            });
        }
    }, {
        key: 'firstSelectedType',
        value: function firstSelectedType() {
            return _.find(this.types, function (type) {
                return type.Value;
            });
        }
    }, {
        key: 'toggleStartDatePicker',
        value: function toggleStartDatePicker() {
            this.startDatePickerOpen = !this.startDatePickerOpen;
        }
    }, {
        key: 'toggleEndDatePicker',
        value: function toggleEndDatePicker() {
            this.endDatePickerOpen = !this.endDatePickerOpen;
        }
    }, {
        key: 'openStartDatePicker',
        value: function openStartDatePicker() {
            this.startDatePickerOpen = true;
            this.updateCalendarStyle();
        }
    }, {
        key: 'openEndDatePicker',
        value: function openEndDatePicker() {
            this.endDatePickerOpen = true;
            this.updateCalendarStyle();
        }
    }, {
        key: 'closeStartDatePicker',
        value: function closeStartDatePicker() {
            this.startDatePickerOpen = false;
        }
    }, {
        key: 'closeEndDatePicker',
        value: function closeEndDatePicker() {
            this.endDatePickerOpen = false;
        }
    }, {
        key: 'openCalendar',
        value: function openCalendar(date) {
            if (this.dateOpeners == "box") {
                if (date == "start") {
                    this.startDatePickerOpen == true ? this.closeStartDatePicker() : this.openStartDatePicker(); // toggle.
                } else if (date == "end") {
                    this.endDatePickerOpen == true ? this.closeEndDatePicker() : this.openEndDatePicker(); // toggle.
                }
            }
        }
    }, {
        key: 'updateCalendarStyle',
        value: function updateCalendarStyle() {
            // Add component styling for calendar that is appended in body.
            setTimeout(function () {
                angular.element('.uib-datepicker-popup').addClass('winres-web-component');
                // angular.element('.uib-datepicker').addClass('departure-search-date-picker-popup');
            });
        }
    }, {
        key: 'getWinresParams',
        value: function getWinresParams() {
            var _this12 = this;

            this.paramService.getWinresParam('CanShowActivities').then(function (param) {
                _this12.showActivities = param.toUpperCase() === 'TRUE';
            });
        }
    }, {
        key: 'getAutoSelectEndDate',
        value: function getAutoSelectEndDate() {
            if (this.autoSelectEndDate && !this.selectedDatePreset && this.$window.location.hash.indexOf('endDate') === -1 && !this.data.DefaultEndDate) {
                var m = new moment(this.startDate);
                this.endDate = m.add(this.autoSelectEndDate, 'days').toDate();
            }
        }
    }]);

    return WinresDeparturesSearchController;
}();

function getTypesFlat(types) {
    var typesFlat = types.reduce((0, _utils2.getFlatTree)(), []);

    // Return flat array of classifications without empty codes.
    return _.filter(typesFlat, function (type) {
        return type.Code !== '';
    });
}

function splitClassifications(classifications) {
    return classifications ? (0, _utils2.clearWhiteSpace)(classifications).split(',') : [];
}

WinresDeparturesSearchController.$inject = ['internetClassificationService', 'busService', 'localizationService', '$scope', '$rootScope', '$timeout', '$filter', '$document', '$window', 'departureService', 'regionService', 'analyticsService', 'userService', 'urlService', 'paramService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils2.getWebcomponentsUrl)($attrs.templateUrl)) : 'departures-search-' + $attrs.mode;
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    var horizontal = require('./winresDeparturesSearchHorizontal.html');
    var vertical = require('./winresDeparturesSearchVertical.html');
    var empty = require('./winresDeparturesSearchEmpty.html');
    $templateCache.put('departures-search-horizontal', horizontal);
    $templateCache.put('departures-search-vertical', vertical);
    $templateCache.put('departures-search-empty', empty);
}]);

// Months are formatted globally as long winresDeparturesSearch.js is being imported.
_module3.default.run(['$locale', function ($locale) {
    return $locale.DATETIME_FORMATS.MONTH = $locale.DATETIME_FORMATS.STANDALONEMONTH;
}]); // Lokakuuta -> Lokakuu.

_module3.default.component('winresDeparturesSearch', {
    templateUrl: getTemplate,
    controller: WinresDeparturesSearchController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        // Ask children ages in num of people form
        askChildrenAges: '@',

        // Set true for searching busses, default: false. Deprecated
        bus: '@',

        // Use current destination code in search criteria
        useCurrentDestination: '@',

        // This forces the use of specified classification, the defaultInternetClassifications1 only sets the initial classification.
        useSpecificClassification: '@',

        // vertical, horizontal or empty. Empty is used when this components functions are required but no UI is needed. This saves ~10kB in loading time.
        mode: '@',

        onUpdate: '&',

        // Destination codes in search criteria
        destinationCodes: '@',

        // Passenger select dropdown type. "select" or "popup"
        passengerCounts: '@',

        // Departure limit for search criteria
        limit: '@',

        // Removes button bar from calendars
        showBtnBar: '@',

        // "true" or "false" (default). If false, doesn't return full
        // departures. If true, it does.
        showFullDepartures: '@',

        // If "box", toggle calendar
        dateOpeners: '@',

        // "true" or "false" (default). If true shows the amount of passenger with text (i.e. "2 persons").
        // If false shows those like 2+0+0 (adults + children + infants)
        passengersInText: '@',

        // Show offers
        defaultOffer: '@',

        // Allow change offer checkbox
        allowChangeOffer: '@',

        // If offer form is shown by default (mode: vertical)
        isOfferOpen: '@',

        // ISO date or +10 (meaning + 10 days)
        defaultStartDate: '@',

        // Allow change start date
        allowChangeStartDate: '@',

        // Show start date. true (default) / false
        showStartDate: '@',

        // If start date form is shown by default (mode: vertical)
        isStartDateOpen: '@',

        // ISO date or +10 (meaning + 10 days)
        defaultEndDate: '@',

        // Allow change end date
        allowChangeEndDate: '@',

        // Show end date. true (default) / false
        showEndDate: '@',

        // Disable end date
        hideEndDate: '@',

        // If end date form is shown by default (mode: vertical)
        isEndDateOpen: '@',

        // When this.type1 is same as value here, the end date is hidden
        hideEndDateWhenSpecifiedSingleType: '@',

        // Add the days of specified. i.e. "+1"
        autoSelectEndDate: '@',

        // Min departure length
        sliderMinLength: '@',

        // Max departure length
        slideMaxLength: '@',

        // Allow change departure length
        allowChangeLength: '@',

        // If departure length form is shown by default
        isLengthOpen: '@',

        // Min departure price
        sliderMinPrice: '@',

        // Max departure price
        sliderMaxPrice: '@',

        // Allow change departure price
        allowChangePrice: '@',

        // If departure length form is shown by default
        isPriceOpen: '@',

        // "true" or "false" (default). If true, initiates
        // Search when the page is loaded.
        searchOnInit: '@',

        // When true, gets the owner info automatically and searches by that data.
        ownerMode: '@',

        // If true: calls the update function when startdate changes. Default: false
        updateOnStartDateChange: '@',

        // Gets the date data from this.data and set min and max dates for startdate-datepicker based on that
        limitDateByData: '@',

        // This adds flag 'K1ExtraAllMatchedPrices' to request. This makes it to return all K1 prices of products. true/false (default)
        k1ExtraAllMatchedPrices: '@',

        // This adds flag 'MatchStartDates' to request. This makes it to find a departure with start date between specified dates. true/false (default)
        matchStartDates: '@',

        // This adds flag 'OrderByPrice' to request. This makes it to return in price order. true/false (default)
        orderByPrice: '@',

        // Minisite. 0 = homepage, 1 = lodging, 2 = activites, 3 = all activities
        dynamicPage: '@',

        // Populate the types2 array on load
        setTypes2Initially: '@',

        // Default internet classifications 1. Separated by ,
        defaultInternetClassifications1: '@',

        // Default internet classifications 2. Separated by ,
        defaultInternetClassifications2: '@',

        // Default internet classifications 3. Separated by ,
        defaultInternetClassifications3: '@',

        // Default internet classifications 4. Separated by ,
        defaultInternetClassifications4: '@',

        // Default internet classifications 5. Separated by ,
        defaultInternetClassifications5: '@',

        // Internet classifications 1 form title (mode: vertical)
        primaryInternetClassificationsTitle: '@',

        // If internet classifications 1 form is open by default  (mode: vertical)
        isPrimaryInternetClassificationsOpen: '@',

        // Allow change internet classifications 1 form  (mode: vertical)
        allowChangePrimaryInternetClassifications: '@',

        // Internet classifications 2 form title  (mode: vertical)
        secondaryInternetClassificationsTitle: '@',

        // If internet classifications 2 form is open by default  (mode: vertical)
        isSecondaryInternetClassificationsOpen: '@',

        // Allow change internet classifications 2 form  (mode: vertical)
        allowChangeSecondaryInternetClassifications: '@',

        // Internet classifications 3 form title  (mode: vertical)
        thirdInternetClassificationsTitle: '@',

        // If internet classifications 3 form is open by default  (mode: vertical)
        isThirdInternetClassificationsOpen: '@',

        // Allow change internet classifications 3 form  (mode: vertical)
        allowChangeThirdInternetClassifications: '@',

        // Internet classifications 4 form title  (mode: vertical)
        fourthInternetClassificationsTitle: '@',

        // If internet classifications 4 form is open by default  (mode: vertical)
        isFourthInternetClassificationsOpen: '@',

        // Allow change internet classifications 4 form  (mode: vertical)
        allowChangeFourthInternetClassifications: '@',

        // Internet classifications 5 form title  (mode: vertical)
        fifthInternetClassificationsTitle: '@',

        // If internet classifications 5 form is open by default  (mode: vertical)
        isFifthInternetClassificationsOpen: '@',

        // Allow change internet classifications 5 form  (mode: vertical)
        allowChangeFifthInternetClassifications: '@',

        // Internet classifications 1 title. If this is set to 'false' it won't display this dropdown
        internetClassificationTitle1: '@',

        // Internet classifications 2 title. If this is set to 'false' it won't display this dropdown
        internetClassificationTitle2: '@',

        // Internet classifications 3 title. If this is set to 'false' it won't display this dropdown
        internetClassificationTitle3: '@',

        // Internet classifications 4 title. If this is set to 'false' it won't display this dropdown
        internetClassificationTitle4: '@',

        // Internet classifications 5 title. If this is set to 'false' it won't display this dropdown
        internetClassificationTitle5: '@',

        // A number or not set. Limits the amount of departures that is displayed per destination
        earliestNDeparturesPerDestination: '@',

        // Infant ages in num of people form
        babyAges: '@',

        // Child ages in num of people form
        childAges: '@',

        // Adult age in num of people form
        adultAge: '@',

        // Show regions dropdown
        showRegionPicker: '@',

        // Preset dates. Separated by comma
        // 'Joulu [startDate;endDate], Syys [startDate;endDate]'
        // 'Joulu [yyyy-kk-dd;yyyy-kk-dd], Syys [yyyy-kk-dd;yyyy-kk-dd]'
        // 'Joulu [2019-12-03;2019-12-06], Syys [2019-09-03;2019-09-07]'
        // Output: '[
        //            Joulu 3 vrk, [weekday] 3.12. - 6.12.,
        //            Syys 4 vrk, [weekday] 3.12. - 7.12.
        //         ']
        datePreset: '@',

        // Show date preset dropdown
        showDatePresetPicker: '@',

        // Default date preset name
        defaultDatePreset: '@',

        // Show discount code input
        showDiscountCode: '@',

        // Show bus stops dropdown
        showBusStops: '@',

        // Number of people limit
        numOfPeopleLimit: '@',

        // Producers split by ,
        producers: '@',

        // Show num of adults +/- in num of people select. Is shown by default. false to hide.
        showNumOfAdults: '@',

        // Show num of children +/- in num of people select. Is shown by default. false to hide.
        showNumOfChildren: '@',

        // Show num of infants +/- in num of people select. Is shown by default. false to hide.
        showNumOfInfants: '@',

        // Hide num of people ages. true/false
        hideAges: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDeparturesSearch/winresDeparturesSearch.js
// module id = 284
// module chunks = 2